module.exports = __webpack_public_path__ + "static/media/tab-3-image-3.9ee9ecf5.jpg";